<template>
  <div class="pa-7" id="topics">
    <!--タイトル-->
    <span class="subHead">
    {{ title }}
    </span>
    <v-icon
    class="mb-2"
    color="blue-grey darken-2">
      {{ icon }}
    </v-icon>
<v-row justify="center" align="center">
<v-col
      lg="7"
      xl="7">
              <v-img :src="src"></v-img>
              </v-col>
</v-row>
    <!--内容-->
          <div class="">
          <v-col v-for="(item, i) in contents"
      :key="i">
         <v-card-title class="descriptiontitle">
        <!--タイトル横アイコン-->
        <v-icon
        class="ml-2 mt-1">
        mdi-arrange-bring-forward
        </v-icon>
              {{ item.descriptiontitle }}
              </v-card-title>
              <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
                {{ item.description }}
              </v-card-text>
            <v-row justify="center" align="center">
            <v-col
      lg="7"
      xl="7"
      justify="center">
            <v-img
            :src="item.src"
            >
            </v-img>
            </v-col>
            </v-row>
            <v-row justify="center" align="center">
            <v-col
      lg="7"
      xl="7">
            <v-img
            :src="item.src2"
            >
            </v-img>
            </v-col>
            </v-row>
              </v-col>
              </div>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
.descriptiontitle{
    font-size: 18px;
  color:#345fb5;
}
hr{
    max-width: 1200px;
}
</style>

<script>
export default {
  data () {
    return {
      // タイトル
      title: 'オンライン査読システム',
      // タイトル横のアイコン
      icon: 'mdi-book-open-outline',
      // 画像
      src: require('../../assets/Products/registration2.png'),
      contents: [
        {
          // 説明タイトル
          descriptiontitle: 'システム',
          // 説明文
          description: `
査読システムでは、演者の演題登録が終了した後に、エディターが、レビューアに演題を割り振ります。割り振られたレビューアが演題をレビュー及び判定し、レビュー終了後、エディターが最終判定をすることになります。`
        },
        {
          // 説明タイトル2
          descriptiontitle: '機能',
          // 説明文2
          description: `
・レビューア(レフェリー)割り振り
・査読コメント通知
・アクセプト、レジェクト一斉メール
・投稿期限、修正期限設定`
        },
        {
          // 説明タイトル2
          descriptiontitle: 'カスタマイズ例',
          // 説明文2
          description: `
準備中`
        },
        {
          // 説明タイトル2
          descriptiontitle: 'オプション',
          // 説明文2
          description: `
・座長割り振り
・部屋割り振り
・全文検索システム
・オプションで、全文検索システムが利用できます。
※検索対象のドキュメントから頻出後を抽出し、類義語を登録するで検索精度をあげることが可能です。`,
          src: require('../../assets/Products/search1.jpg'),
          src2: require('../../assets/Products/search2.jpg')
        },
        {
          // 説明タイトル2
          descriptiontitle: '利用料金',
          // 説明文2
          description: `
準備中`
        }
      ]
    }
  }
}
</script>
